/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Tax {
    angular.module("meevo.plugins.tax", []);
}